import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LaunchPage from "@/pages/LaunchPage";
import PackagesPage from "@/pages/PackagesPage";
import PortfolioPage from "@/pages/PortfolioPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import QuestionnairePage from "@/pages/QuestionnairePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminQuestionnaire from "@/pages/AdminQuestionnaire";
import AdminSpreadsheets from "@/pages/AdminSpreadsheets";

function App() {
    return (
        <div className="App min-h-screen">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LaunchPage />} />
                    <Route path="/packages" element={<PackagesPage />} />
                    <Route path="/portfolio" element={<PortfolioPage />} />
                    <Route path="/questionnaire" element={<QuestionnairePage />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsConditions />} />
                    <Route path="/admin" element={<AdminLogin />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin/dashboard" element={<AdminQuestionnaire />} />
                    <Route path="/admin/questionnaire" element={<AdminQuestionnaire />} />
                    <Route path="/admin/spreadsheets" element={<AdminSpreadsheets />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="top-center"
                toastOptions={{
                    style: {
                        background: '#0A0A0A',
                        border: '1px solid rgba(212,175,55,0.3)',
                        color: '#fff',
                        fontFamily: 'Manrope, sans-serif',
                    },
                }}
            />
        </div>
    );
}

export default App;
